import { PermissionService } from 'src/services/permission.service';
import {
  DEFAULT_PAGE,
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import { AppAction } from './app.action';

export const PERMISSION_LIST_SUCCESS = 'PERMISSION:FIND_ALL_SUCCESS'
export const PERMISSION_LIST_FAILD = 'PERMISSION:FIND_ALL_FAILD'

export const PERMISSION_CREATE_SUCCESS = 'PERMISSION:CREATE_SUCCESS'
export const PERMISSION_CREATE_FAILD = 'PERMISSION:CREATE_FAILD'

export const PERMISSION_DEL_SUCCESS = 'PERMISSION:DEL_SUCCESS'
export const PERMISSION_DEL_FAILD = 'PERMISSION:DEL_FAILD'

export const PERMISSION_UPDATE_FILTER = 'PERMISSION:PERMISSION_UPDATE_FILTER'

export const PermissionAction = {
  list,
  updateFilter,
}

function updateFilter(payload) {
  return { type: PERMISSION_UPDATE_FILTER, data: payload }
}

function list() {
  return (dispatch, getState) => {
      dispatch(AppAction.appLoading(true));
      const { permission } = getState();
      const page = permission && typeof permission.filter !== 'undefined' && permission.filter && typeof permission.filter.page !== 'undefined' ? permission.filter.page : 0;
      const limit = permission && typeof permission.filter !== 'undefined' && permission.filter && typeof permission.filter.limit !== 'undefined' ? permission.filter.limit : 10;
      PermissionService.findAll(page, limit, permission.filter).then((rs) => {
          if (page === 0) {
              dispatch(success({
                  items: rs.data.values,
                  total: rs.data.count,
              }));
          } else {
              const oldItems = permission.items;
              const rsDataValues = rs.data.values;

              var uniqueItems = oldItems;
              for (var i = limit * page; i < limit * page + limit; i++) {
                  if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                      uniqueItems[i] = rsDataValues[i - limit * page];
                  } else if (typeof uniqueItems[i] !== 'undefined') {
                      delete uniqueItems[i];
                  }
              }
              
              dispatch(success({
                  items: uniqueItems,
                  total: rs.data.count,
              }));
          }
      }).catch((error) => {
          dispatch(failure(error));
      }).finally(() => {
          dispatch(AppAction.appLoading(false));
      })
  };
  function success(data) { return { type: PERMISSION_LIST_SUCCESS, data } }
  function failure(error) { return { type: PERMISSION_LIST_FAILD, error } }
}